<template lang="pug">
v-row(no-gutters)
  v-col.pa-10(cols="3")
    .sticky.top-24.white
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/business-details')") {{ $t('business_details') }}
      .text-md.font-semibold.neutral500--text.px-4.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/tax')") {{ $t('tax_settings') }}
      .text-md.font-semibold.neutral200.px-4.py-2.round-md.mb-2 {{ $t('payment_gateway') }}

  v-col.neutral200(cols="9")
    v-container.pa-8
      .d-flex.align-center.mb-6
        v-btn.mr-4(icon small)
          v-icon(color="primary" @click="back") mdi-arrow-left
        .text-2xl.font-semibold {{ $t('payment_gateway') }}

      v-card.round-xl.pa-4.mb-4(outlined)
        v-col(cols="8")
          .h8.mb-1 Payment gateway settings
          .text-sm.font-medium Configure your payment gateway settings

</template>

<script>
export default {
  methods: {
    back () {
      this.$router.push('/admin/clinic/settings')
    },
  }
}
</script>